import React from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://moyobed.pro';

function ExportTab({ companyId }) {
  const handleExport = async (endpoint) => {
    try {
      const formData = new FormData();
      formData.append('company_id', companyId);
      const res = await axios.post(`${API_URL}${endpoint}`, formData);
      window.open(`${API_URL}${res.data.download_url}`, '_blank');
    } catch(err) {
      alert('Ошибка: ' + (err.response?.data?.detail || err.message));
    }
  };

  const handleReport = async () => {
    const month = document.getElementById('reportMonth').value;
    const year = document.getElementById('reportYear').value;
    const formData = new FormData();
    formData.append('company_id', companyId);
    formData.append('month', month);
    formData.append('year', year);
    try {
      const res = await axios.post(`${API_URL}/api/admin/report-monthly`, formData);
      window.open(`${API_URL}${res.data.download_url}`, '_blank');
    } catch(err) {
      alert('Ошибка: ' + (err.response?.data?.detail || err.message));
    }
  };

  return (
    <div className="tab-panel">
      <h2 className="tab-title">📥 Выгрузка данных</h2>

      <div className="card" style={{ marginBottom: 16 }}>
        <h3>📊 Месячный отчёт по обедам</h3>
        <p className="form-hint">Excel-файл с количеством обедов по дням для каждого сотрудника</p>
        <div style={{ display: 'flex', gap: 8, marginTop: 12, alignItems: 'center', flexWrap: 'wrap' }}>
          <select className="input" id="reportMonth" defaultValue={new Date().getMonth() + 1} style={{ width: 'auto' }}>
            <option value="1">Январь</option>
            <option value="2">Февраль</option>
            <option value="3">Март</option>
            <option value="4">Апрель</option>
            <option value="5">Май</option>
            <option value="6">Июнь</option>
            <option value="7">Июль</option>
            <option value="8">Август</option>
            <option value="9">Сентябрь</option>
            <option value="10">Октябрь</option>
            <option value="11">Ноябрь</option>
            <option value="12">Декабрь</option>
          </select>
          <input className="input" id="reportYear" type="number" defaultValue={new Date().getFullYear()} style={{ width: '100px' }} min="2020" max="2100" />
          <button className="btn" onClick={handleReport}>📊 Сформировать отчёт</button>
        </div>
      </div>

      <div className="card" style={{ marginBottom: 16 }}>
        <h3>📋 Выгрузить меню с количествами</h3>
        <p className="form-hint">Excel-файл с шаблоном меню и количеством заказов</p>
        <button className="btn" onClick={() => handleExport('/api/admin/export-menu')}>📥 Скачать меню</button>
      </div>

      <div className="card" style={{ marginBottom: 16 }}>
        <h3>👥 Выгрузить заказы по сотрудникам</h3>
        <p className="form-hint">Excel-файл с отдельными листами для каждого сотрудника</p>
        <button className="btn" onClick={() => handleExport('/api/admin/export-employees')}>📥 Скачать заказы</button>
      </div>

      <div className="card">
        <h3>💾 Выгрузить список сотрудников</h3>
        <p className="form-hint">Excel-файл со списком всех активных сотрудников</p>
        <button className="btn" onClick={() => handleExport('/api/admin/employees/export')}>📥 Скачать список</button>
      </div>
    </div>
  );
}

export default ExportTab;
